module.exports = __webpack_public_path__ + "img/1.c1e38f17.png";